<template>
  <div class="xd-input-form">
      <div class="xd-label">{{label}}</div>
      <input :placeholder="placeHolder" ref="input" @input="onInput" :style="inputStyle" @blur="onInputBlur" :class="[validStatus ? '': 'valid','xd-input default-xd-input',type === 'intl' ? 'input-intel-tel mobileInput default-xd-input' : '']" :type="inputType" v-model="inputValue" @change="onInputChangeInner" />
      <div class="rule" v-if="valid && !validStatus">{{message}}</div>
  </div>
</template>

<script>
// import 'intl-tel-input/build/css/intlTelInput.css'
// import intlTelInput from 'intl-tel-input'

export default {
  name: 'Input',
  data () {
    return {
      inputStyle: this.$props.label.length > 0 ? {
        'margin-top': '8px'
      } : {},
      instance: null,
      inputValue: '',
      validStatus: true,
      inputType: 'text'
    }
  },
  props: {
    vaildStatusProps: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    setInstance: {
      type: Function,
      default: () => {}
    },
    message: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '',
      requird: false
    },
    placeHolder: {
      type: String,
      default: () => {}
    },
    value: {
      type: String,
      default: () => {}
    },
    onInputChange: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    value () {
      this.inputValue = this.value
    },
    vaildStatusProps (e) {
      console.log('e', e)
      this.validStatus = e
    }
  },
  mounted () {
    if (this.type === 'intl') {
      // eslint-disable-next-line no-undef
      this.instance = $(this.$refs.input)
      this.setInstance(this.instance)
      this.instance.intlTelInput({
        initialCountry: 'cn',
        preferredCountries: ['cn']
      })
    }
    this.inputValue = this.value
    if (this.type === 'intl' || this.type === 'number') {
      this.inputType = 'number'
    }
  },
  methods: {
    onInputBlur (e) {
      if (e.target.value.length === 0) {
        this.validStatus = false
        event.preventDefault()
        event.stopPropagation()
      }
    },
    onInput (e) {
      if (this.type === 'number') {
        // e.target.value = e.target.value.replaceAll('\\pP|\\pS', '')
      }
      if (e.target.value.length === 0) {
        this.validStatus = true
        // event.preventDefault()
        // event.stopPropagation()
      }
      this.onInputChange(e.target.value)
    },
    onInputChangeInner (e) {
      if (this.type === 'intl') {
        this.validStatus = this.instance.intlTelInput('isValidNumber')
      }
      if (this.type === 'name') {
        const regex = RegExp(/^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/)
        this.validStatus = regex.test(e.target.value)
      }
      if (this.type === 'id') {
        const regex = RegExp(/(\d{15}$)|(^\d{18}$)|(\d{17}(\d|X|x)$)/)
        this.validStatus = regex.test(e.target.value)
      }
      if (this.type === 'number') {
        const regex = RegExp(/^[0-9][A-Za-z0-9 -]*$/)
        this.validStatus = regex.test(e.target.value)
      }
      if (e.target.value.length === 0) {
        this.validStatus = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
// .iti__flag {background-image: url("path/to/flags.png");}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
//   .iti__flag {background-image: url("path/to/flags@2x.png");}
}
.valid{
  border: 1px solid red !important;
}
input{
  padding: 10px 12px 10px 12px;
}
.mobileInput{
  padding-left:47px !important;
}
.rule{
    text-align: left;
    margin-top: 8px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    letter-spacing: 2.87879e-09px;

    /* 红色 */

    color: #FF0000;
}
.xd-label{
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */
    letter-spacing: 4.93507e-09px;
    /* 黑色 */
    color: #333333;
}
.xd-input {
  background: #ffffff;
  /* border */
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-radius: 3px;
  height: 44px;
  width: 100%;
  // padding-left: 5px;
}
</style>
